const isWebAuthnSupported = () => window.PublicKeyCredential !== undefined;

const events = {
  webAuthnSupported: {
    eventCd: 'webauthn',
    meta: {
      screenId: 'wait_screen',
      detail: 'supported',
    },
  },
  webAuthnNotSupported: {
    eventCd: 'webauthn',
    meta: {
      screenId: 'wait_screen',
      detail: 'not_supported',
    },
  },
  platformAuthnAvailable: {
    eventCd: 'webauthn',
    meta: {
      screenId: 'wait_screen',
      elementId: 'platform_authenticator',
      detail: 'available',
    },
  },
  platformAuthnNotAvailable: {
    eventCd: 'webauthn',
    meta: {
      screenId: 'wait_screen',
      elementId: 'platform_authenticator',
      detail: 'unavailable',
    },
  },
};

const logs = {
  publicKeyCredentialError: 'PUBLIC_KEY_CREDENTIAL_ERROR',
};

export { isWebAuthnSupported, events, logs };
